import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data, SelectUsers } from "../../../utils/common";

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get All (for a specific state)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);
      return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// District - Get All (for a specific city)
export const AllDistrict = createAsyncThunk(
  "common/masters/all-district/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllDistrict}/${cityId}?name=${name}`
      );
      return await Select2Data(res.data.data, "district_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ districtId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${districtId}?name=${name}`
      );
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllCategory = createAsyncThunk(
  "common/productmanage/all-category",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCategory);

      return await Select2Data(res.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllPartners = createAsyncThunk(
  "common/productmanage/all-partners",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPartners);

      return await Select2Data(res.data, "partners_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// State - Get All (for a specific country)
export const AllSubCategory = createAsyncThunk(
  "common/productmanage/all-subcategory/:id",
  async (categoryId, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubCategory}/${categoryId}`);

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data, "subcategory_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get All (for a specific state)
export const GetAllChildCategory = createAsyncThunk(
  "common/masters/all-city/:id",
  async (stateId, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllChildCategory}/${stateId}`);
      return await Select2Data(res.data, "childcategory_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllWhyChooseUs = createAsyncThunk(
  "common/masters/all-whychooseus",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllWhyChooseUs);

      return await Select2Data(res.data, "whychooseus_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllIndustry = createAsyncThunk(
  "common/masters/all-industry",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllIndustry);

      return await Select2Data(res.data, "industry_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllDepartment = createAsyncThunk(
  "common/masters/all-department",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllDepartment}?name=${filter}`);

      return await Select2Data(res.data.data, "department_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllCompanySize = createAsyncThunk(
  "common/masters/all-companysize",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCompanySize}?name=${filter}`);

      return await Select2Data(res.data.data, "companysize_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllNeeds = createAsyncThunk(
  "common/productmanage/all-needs",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllNeeds);

      return await Select2Data(res.data, "needs_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllFaq = createAsyncThunk(
  "common/masters/all-faqs",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllFaq}?name=${filter}`);

      return await Select2Data(res.data.data, "faqs_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// SubFaq - Get All (for a specific faq)
export const AllSubFaq = createAsyncThunk(
  "common/masters/all-subfaq/:id",
  async ({ faqsId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubFaq}/${faqsId}?name=${name}`);

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "subfaq_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllSocialMedia = createAsyncThunk(
  "common/productmanage/all-socialmedia",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSocialMedia);

      return await Select2Data(res.data, "socialmedia_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllStatus = createAsyncThunk(
  "common/masters/all-user-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllUserStatus}?amount=${filter}`);

      return await Select2Data(res.data.data, "status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllUsers = createAsyncThunk(
  "common/masters/all-users",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllUser}`);

      return await SelectUsers(res.data.data, "user_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllAppSetUp = createAsyncThunk(
  "common/masters/app-setup",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Customization.AppSetUp}`);

      return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllCompany = createAsyncThunk(
  "common/masters/all-company",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCompany}?name=${filter}`);

      return await Select2Data(res.data.data, "company_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllWithdrawStatus = createAsyncThunk(
  "common/masters/all-withdraw-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWithdrawStatus}?name=${filter}`);

      return await Select2Data(res.data.data, "withdraw_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_city: [],
    all_district: [],
    all_pincode: [],
    all_category: [],
    all_subcategory: [],
    all_partners: [],
    all_whychooseus: [],
    all_industry: [],
    all_department: [],
    all_companysize: [],
    all_needs: [],
    all_faqs: [],
    all_subfaq: [],
    all_socialmedia: [],
    all_user_status: [],
    all_user: [],
    all_company: [],
    all_withdraw_status: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllDistrict.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDistrict.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_district = action.payload || [];
      })
      .addCase(AllDistrict.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllSubCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subcategory = action.payload || [];
      })
      .addCase(AllSubCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllPartners.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPartners.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_partners = action.payload || [];
      })
      .addCase(AllPartners.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllWhyChooseUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllWhyChooseUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whychooseus = action.payload || [];
      })
      .addCase(AllWhyChooseUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllIndustry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllIndustry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_industry = action.payload || [];
      })
      .addCase(AllIndustry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllDepartment.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDepartment.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_department = action.payload || [];
      })
      .addCase(AllDepartment.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCompanySize.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCompanySize.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_companysize = action.payload || [];
      })
      .addCase(AllCompanySize.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_needs = action.payload || [];
      })
      .addCase(AllNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllFaq.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFaq.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_faqs = action.payload || [];
      })
      .addCase(AllFaq.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllSubFaq.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubFaq.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subfaq = action.payload || [];
      })
      .addCase(AllSubFaq.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllSocialMedia.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSocialMedia.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_socialmedia = action.payload || [];
      })
      .addCase(AllSocialMedia.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_user_status = action.payload || [];
      })
      .addCase(AllStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllUsers.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUsers.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_user = action.payload || [];
      })
      .addCase(AllUsers.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_user_status = action.payload || [];
      })
      .addCase(AllAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllWithdrawStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllWithdrawStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_withdraw_status = action.payload || [];
      })
      .addCase(AllWithdrawStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCompany.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCompany.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_company = action.payload || [];
      })
      .addCase(AllCompany.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
